import { STATUS_BADGE_TONE_PALETTES, StatusBadge } from "@components";
import {
	EXPENSE_STATUS_BADGE_ICONS,
	EXPENSE_STATUS_BADGE_TONES,
	EXPENSE_STATUS_LABELS,
} from "../constants";
import { vehicleSituationLabel } from "../handlers";
import type { ExpenseStatus, VehicleRankingItem } from "../types";
import { formatCurrency } from "../utils";
import { VehicleExpenseTotalsByType } from "./vehicle-expense-totals-by-type";
import { VehicleExpenseTrend } from "./vehicle-expense-trend";

type VehicleExpenseCardProps = {
	item: VehicleRankingItem;
};

export const VehicleExpenseCard = ({ item }: VehicleExpenseCardProps) => {
	const status = item.status as Exclude<ExpenseStatus, 0>;
	const palette =
		STATUS_BADGE_TONE_PALETTES[EXPENSE_STATUS_BADGE_TONES[status]];
	const StatusIcon = EXPENSE_STATUS_BADGE_ICONS[status];
	const statusLabel = EXPENSE_STATUS_LABELS[status];

	// só aparecer se o veículo não estiver disponível
	const vehicleSituation = vehicleSituationLabel(item.vehicleStatus);

	return (
		<article
			aria-label={`Despesas do veículo ${item.plate}`}
			className="flex min-w-0 flex-col rounded-xl border border-border-primary bg-white p-5 shadow-xs"
		>
			<div className="flex flex-wrap items-start justify-between gap-2">
				<div className="min-w-0">
					<p className="font-bold text-sm text-tertiary">{item.plate}</p>
					<p className="break-words text-quaternary text-sm">
						<span className="font-bold text-primary text-sm">{`${item.brand ? `${item.brand} -` : ""} ${item.model ? `${item.model} ` : ""}`}</span>
						{vehicleSituation}
					</p>
				</div>
				<StatusBadge
					label={
						<span className="inline-flex items-center gap-1">
							<StatusIcon aria-hidden className="size-3.5 shrink-0" />
							{statusLabel}
						</span>
					}
					palette={palette}
					showDot={false}
				/>
			</div>

			<p className="mt-4 break-words font-bold text-2xl text-primary leading-8">
				{formatCurrency(item.totalCurrentMonth)}
			</p>

			<VehicleExpenseTrend data={item} />

			<VehicleExpenseTotalsByType totalsByType={item.totalsByType || []} />
		</article>
	);
};
